<template>
  <v-card class="back" style="height: 700px">

        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span v-if="addMode" class="body-2 text-uppercase">{{$t('add new entry')}}</span>
                  <span v-if="!addMode && getData.name && !getData.hasOwnProperty('full_name')" class="body-2 text-uppercase">{{ getData.name }}</span>
                  <span v-if="!addMode && getData.hasOwnProperty('full_name')" class="body-2 text-uppercase">{{ getData.full_name }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                  <v-tooltip dark color="secondary" bottom>
                    <v-btn icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'close'"
                    @click="()=>{$emit('close')}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>
                </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout column  justify-start class="pa-1">
                <v-form ref="book_card_form">

                  <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true'" >
                    <v-flex xs4 shrink v-if="field.name != 'push_active' && field.type != 'boolean' && field.type != 'timestamp'" px-0 pb-1>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    </v-flex>
                    
                    <v-flex xs8 shrink px-0>

                      <v-text-field
                        v-if="field.type == 'integer'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model.number="model.obj[field.name]"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        :type="'number'"
                        light
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="(field.type == 'text') && field.name != 'password' && field.name != 'push_active'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        :rules="field.name == 'name' || model.fields[field.name]?.required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        light
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="field.type == 'text' && field.name == 'password'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :type="visible ? 'text' : 'password'"
                        @click:append="() => (visible = !visible)"
                        :append-icon="visible ? 'visibility' : 'visibility_off'"
                        required
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-select
                        v-if="(field.type == 'select' || field.type == 'select_enum')"
                        :data-testid="$options.name + '__select__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        required
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        outline
                        clearable
                        hide-details
                        class="white"
                        background-color="backgrey"
                      >
                        <template v-slot:item="{ item, index }">
                            <span v-if="item.full_name">{{ item.full_name }}</span>
                            <span v-else>{{ field.type == 'select' ? item.name : item.value }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span v-if="item.full_name">{{ item.full_name }}</span>
                            <span v-else>{{ field.type == 'select' ? item.name : item.value }}</span>
                        </template>
                      </v-select>

                      <v-checkbox
                        small
                        light
                        color="secondary"
                        v-if="field.type == 'boolean' || field.name == 'push_active'"
                        :data-testid="$options.name + '__checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>

                    </v-flex>

                  </v-layout>

                  <v-layout shrink >
                    <v-flex shrink v-for="(field, index) in getFields" :key="index + '_timestamp'" v-if="field.type == 'timestamp'"  pr-3 pb-1>
                      <date-picker
                        :value="model.obj[field.name]"
                        :label="$t(field.name)"
                        @dateChange="(payload) => dateMethod(field.name, payload)"
                      />
                    </v-flex>
                  </v-layout>

                </v-form>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>
                  <v-btn v-if="addMode" dark-- small :disabled="checkNameFilled" :data-testid="$options.name + '__btn__' + 'createData'" @click="()=>createData()" color="success">{{$t('add')}}</v-btn>
                  <v-btn v-if="!addMode" dark small :data-testid="$options.name + '__btn__' + 'saveData'" @click="()=>saveData()" color="success">{{$t('save')}}</v-btn>
                  <v-btn v-if="!addMode"dark small :data-testid="$options.name + '__btn__' + 'removeItem'" @click="()=>removeItem()" color="secondary">{{$t('remove')}}</v-btn>
                </v-layout>
                <v-layout fill-height justify-end>
                  <v-btn dark small :data-testid="$options.name + '__btn__' + 'close'" @click="()=>{$emit('close')}" color="secondary">{{$t('close')}}</v-btn>                 
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>

  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'

// Типы

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  items: Record<string, any>
  refs: Record<string, any>
}

interface MetaData {
  [key: string]: any
}

interface BookData {
  $id?: string
  name?: string
  [key: string]: any
}

interface BookMeta {
  cls?: string
  name?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'BOOK_CARD',

  components: {
    loadingCircle,
    scrollTable,
    scrollArea,
    svgIcon,
    datePicker
  },

  props: {
    data: {
      type: Object as () => BookData,
      default: () => ({})
    },
    childrenMeta: {
      type: Object as () => BookMeta,
      default: () => ({})
    },
    addMode: {
      type: Boolean,
      default: () => false
    },
  },

  data(): {
    err: string
    meta: MetaData | null
    model: ModelData
    visible: boolean
  } {
    return {
      err: '',
      meta: null,
      model: {
        fields: {},
        obj: {},
        items: {},
        refs: {},
      },
      visible: false,
    }
  },

  computed: {
    getData(): BookData {
      return this.data
    },
    getChildrenMeta(): BookMeta {
      return this.childrenMeta
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    checkNameFilled(): Record<string, any> {
      return (this.model.fields.hasOwnProperty('name') && !this.model.obj.name) ? true : false
    },
  },

  watch: {

  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.reset()
      this.loadMeta()
    },

    async loadMeta(): Promise<void> {
      console.log(this.$options.name, 'loadMeta', 'this.getData', this.getData)
      // if(!this.getData?.cls) return
      if(this.getData?.cls) {
        this.meta = await this.$loadMeta(this.getData.cls)
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          if (!this.addMode) {
            this.prepareData()
          }
        }
      }
      else if(this.getChildrenMeta?.cls) {
        this.meta = this.getChildrenMeta
        this.model = await this.$prepareMeta(this.meta, this.$options.name)
      }
      console.log(this.$options.name, '$prepareMeta', 'meta', this.meta)
    },

    async prepareData(obj?: any): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model
      } catch (error) {
        this.setLoader('loadMeta', false)
      }
    },

    removeItem(): void {
      // console.log(this.$options.name, 'removeItem', 'this.getData', this.getData)
      let name = this.getData.name
      if(this.getData.hasOwnProperty('full_name')){
        name = this.getData.full_name ? this.getData.full_name : ''
      }
      this.$dialog.confirm({
        text: `Удалить ${name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              this.$emit('remove', this.getData)
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      try {
        if(!this.model.obj?.name || !this.model.obj.name.length) {
          this.$dialog.notify.error('Поле "имя" не должно бчть пустым', { timeout: 5000 })
          return
        }
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                this.$emit('update', {
                  item: this.getData,
                  data: this.model.obj
                })
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async createData(): Promise<void> {
      try {
        const formRef = this.$refs['book_card_form'] as any
        const v = formRef?.validate() ?? false
        if (!v) return

        this.$dialog.confirm({
          text: 'Добавить новую запись в справочник?',
          title: 'Добавить новую запись в справочник',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Добавить',
              handle: () => {
                this.$emit('add', this.model.obj)
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    dateMethod(name: string, val: string): void {
      // console.log('dateMethod name', name, 'val', val)
      this.$set(this.model.obj, name, new Date(val))
    },

    reset(): void {
      this.meta = null
      this.model = {
        fields: {},
        obj: {},
        items: {},
        refs: {},
      }
      this.visible = false
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
